import { PropsWithChildren } from 'react'
import { useAuth } from './useAuth'
import { tieneRol } from './roles'

interface RoleGuardProps extends PropsWithChildren {
  roles: string[]
}

export function RoleGuard({ roles, children }: RoleGuardProps) {
  const { user, isLoading } = useAuth()

  // Cada RoleGuard pide su propio /auth/me: mientras llega no hay roles todavía, y abrir directamente
  // una página del backoffice (p. ej. /admin/temporadas) mostraba «Sin permiso» (detectado en prod,
  // 2026-11-01). Hasta tener la respuesta, solo se muestra que está cargando.
  if (isLoading) {
    return <p>Cargando… / Kargatzen…</p>
  }

  if (!tieneRol(user, ...roles)) {
    return <p>Sin permiso / Baimenik ez</p>
  }

  return <>{children}</>
}
